import React, { useState } from "react";
import SideBar from "../../../components/SideBar";
import Navigation from "../../../components/Navigation";
import Footer from "../../../components/Footer";
import LogOutModal from "../../../components/modals/LogOutModal";

const StatementIndex = () => {
  const [open, setOpen] = useState(false);
  const toggleLogOutModal = () => {
    setOpen(!open);
  };

  const pageTitle = "Statements";
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "Statements" }];
  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-slate-500">
      <SideBar options={{ open, toggleLogOutModal }} />
      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200">
        {/* navigation */}
        <Navigation pageTitle={pageTitle} breadcrumbs={breadcrumbs} />

        <div className="w-full px-6 py-6 mx-auto">
          <Footer />
        </div>
      </main>
      <LogOutModal options={{ open, setOpen, toggleLogOutModal }} />
    </div>
  );
};

export default StatementIndex;
